import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { addAdminUser, editAdminUser } from 'actions/managePermissions'
import ManagePermissionsView from 'views/ManagePermissions/ManagePermissions'

class ManagePermissions extends Component {
  static propTypes = {
    currentUserId: PropTypes.string,
    forms: PropTypes.object,
    hide: PropTypes.func,
    id: PropTypes.string,
    managePermissions: PropTypes.object,
    modals: PropTypes.object,
  }

  static defaultProps = {
    id: 'managePermissions',
  }

  _submit = (data, type) => {

    if (type === 'add') {
      this.props.dispatch(addAdminUser(data, this.props.currentUserId, this.props.id))
    } else {
      this.props.dispatch(editAdminUser(data, this.props.currentUserId, this.props.id))
    }
  }

  render() {
    const {
      modals, hide, forms, id, managePermissions, metaData, currentUserId, dispatch,
    } = this.props

    return (
      <ManagePermissionsView
        currentUserId={currentUserId}
        description="Select a user type to manage admin permissions"
        dispatch={dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        managePermissions={managePermissions}
        metaData={metaData}
        modals={modals}
        title="Manage permissions"
      />
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  managePermissions: state.managePermissions,
  modals: state.modals,
  forms: state.forms,
  metaData: state.mdm,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManagePermissions))



// WEBPACK FOOTER //
// ./src/containers/ManagePermissions.js